// extracted by mini-css-extract-plugin
export default {"header":"I__Bzg9L","footer":"_2BhYljrf"};